var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 1.5,
    stroke: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0702 13.7592L14.9995 13.6885L14.9288 13.7592L11.0488 17.6392C10.6992 17.9889 10.1222 17.9816 9.76978 17.6388C9.4193 17.2878 9.41945 16.7214 9.77024 16.3707L14.3602 11.7807C14.7112 11.4297 15.2779 11.4297 15.6288 11.7807L20.2188 16.3707C20.5698 16.7216 20.5698 17.2883 20.2188 17.6392C19.8679 17.9902 19.3012 17.9902 18.9502 17.6392L15.0702 13.7592Z",
    fill: "#85593E",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.af011c81258999ef310edad0eebf925d.svg";
export { ForwardRef as ReactComponent };